<template>
  <div class="localizedService">
    <BannerImg :img-url="$StaticFileUrl + '/mp/BannerImage/localized_service_TO_banner.jpg'">
      <div class="title wow fadeInDown" data-wow-duration="1s">本地化服务流量运营解决方案</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">通过数字化营销，助力互联网+服务业流量变现</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即咨询</div>
        <div class="btn-red-linear wow flipInX" data-wow-duration="1s" style="margin-top: 100px">免费试用</div>
      </div>
    </BannerImg>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
import BannerImg from '@/components/BannerImg'
export default {
  name: 'LocalizedService',
  components: {
    BannerImg,
  },
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
